import React from "react";
import { ModalTemplate } from "../../templates/ModalTemplate";
import { OwnerForm, OwnerFormData } from "../form/OwnerForm";
import { useOwnerToast, useOwnerPage, useOwnerEditing } from "../../pages/owners/hook";
import { Toast } from "../../atoms/Toast";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onSubmit?: (data: OwnerFormData) => void;
  defaultValues?: Partial<OwnerFormData>;
  ownerId?: string;
  refetchOwners?: () => void;
};

export const EditOwnerModal: React.FC<Props> = ({
  isOpen,
  onClose,
  onSubmit,
  defaultValues,
  ownerId,
  refetchOwners
}) => {
  const { toast, showToast, hideToast } = useOwnerToast();
  const { handleEditOwner } = useOwnerEditing(showToast, refetchOwners, onClose);

  const handleFormSubmit = (data: OwnerFormData, onError: (message: string) => void) => {
    if (!ownerId) {
      onError('Owner ID is missing.');
      return;
    }
    handleEditOwner(
      {
        name: data.name,
        email: data.email,
        phone_number: data.phoneNumber,
        other_phone_number: data.otherPhoneNumber,
      },
      ownerId,
      onError,
      () => {
        onSubmit?.(data);
      }
    );
  };

  if (!isOpen) return null;

  return (
    <div>
      {toast.visible && (
        <Toast
          message={toast.message}
          type={toast.type}
          onClose={hideToast}
        />
      )}
      <ModalTemplate
        isOpen={isOpen}
        title="Update Owner"
        onClose={onClose}
      >
        <OwnerForm handleSubmit={handleFormSubmit} defaultValues={defaultValues} mode="edit" />
      </ModalTemplate>
    </div>
  );
};
